import { render } from "./AlternativeFooter.vue?vue&type=template&id=43cdfb5d&scoped=true"
import script from "./AlternativeFooter.vue?vue&type=script&lang=js"
export * from "./AlternativeFooter.vue?vue&type=script&lang=js"

import "./AlternativeFooter.vue?vue&type=style&index=0&id=43cdfb5d&scoped=true&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cdfb5d"]])

export default __exports__